import request, { ResponseData, PagerData } from '@/libs/request/request'
import { VillageQuery } from 'src/api/village/VillageQuery'

// Village
export type Village = {

  // 地址
  address?:string

  // 城市
  city?:string

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 业务Id
  id?:number

  // 轮播图场景名称
  name?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 标题
  version?:number

  // 族谱联系人
  contacts?:string

  // 手机号
  phone?:string

  // 县（区）
  area?:string

  // 省
  province?:string
}

export default class VillageService {
  /**
   * 添加一个村庄
   * @param {Village} item 村庄实体
   **/
  static addOneVillage (item?:Village):Promise<ResponseData<Village>> {
    return request<ResponseData<Village>>({
      method: 'POST',
      data: item,
      url: '/admin/Village/Village'
    })
  }

  /**
   * 更新一个村庄
   * @param {Village} item 村庄实体
   **/
  static updateOneVillage (item?:Village):Promise<ResponseData<Village>> {
    return request<ResponseData<Village>>({
      method: 'PUT',
      data: item,
      url: '/admin/Village/Village'
    })
  }

  /**
   * 获取村庄的分页数据
   * @param {VillageQuery} query 村庄实体查询条件
   **/
  static getPagesOfVillage (query?:VillageQuery):Promise<ResponseData<PagerData<Village>>> {
    return request<ResponseData<PagerData<Village>>>({
      method: 'POST',
      data: query,
      url: '/admin/Village/Village/pages'
    })
  }

  /**
   * 通过id获取一个村庄
   * @param {number} id 村庄id
   **/
  static getOneVillage (id:number):Promise<ResponseData<Village>> {
    return request<ResponseData<Village>>({
      method: 'GET',
      url: `/admin/Village/Village/${id}`
    })
  }

  /**
   * 删除一个村庄
   * @param {number} id 村庄id
   **/
  static deleteOneVillage (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/Village/Village/${id}`
    })
  }
}
